import {
  SweepDestGroupType,
  SweepDestStatus,
} from "@wallet-manager/node-types/dist/src/postgres/const";
import { Fragment } from "react";
import ChainNameSingleSelection from "src/components/ContractSweepRecipientSetting/ChainNameSingleSelection";
import CurrencySingleSelection from "src/components/ContractSweepRecipientSetting/CurrencySingleSelection";
import {
  NodeTypesEnumSingleSelection,
  SingleSelection,
} from "src/components/GeneralSelection";
import MpTextField from "src/components/MpTextField";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { useTranslation } from "src/hooks";
import { genField } from "src/utils/HelperComp";
import { FilterFields, FilterFieldsKeys } from "../types/FilterFields";
import { TableColumnKey } from "../types/Table";

const useRenderFilters = () => {
  const { translatePrefix, fields, setFields } = usePageConfigProviderContext<
    FilterFields,
    unknown
  >();
  const { t, tc, te, translate } = useTranslation(translatePrefix);

  const toYesNo = (name: string) => {
    switch (name) {
      case "true":
        return te("yes");
      case "false":
        return te("no");
    }
    return "";
  };

  const filterFields = genField({ t }, [
    [
      TableColumnKey.ChainName,
      <ChainNameSingleSelection
        fieldName={t(TableColumnKey.ChainName)}
        value={fields[FilterFieldsKeys.ChainName]}
        onChange={(e) =>
          setFields((f) => ({ ...f, chainName: e.target.value }))
        }
      />,
    ],
    [
      TableColumnKey.Currency,
      <CurrencySingleSelection
        fieldName={t(TableColumnKey.Currency)}
        onChange={(e) =>
          setFields((fields: any) => ({
            ...fields,
            assetName: e.target.value,
          }))
        }
        value={fields[FilterFieldsKeys.AssetName]}
        chainName={fields.chainName}
      />,
    ],
    [
      TableColumnKey.GroupSequence,
      <MpTextField
        label={tc("phInputField", {
          fieldName: t(TableColumnKey.GroupSequence),
        })}
        value={fields[FilterFieldsKeys.GroupSequence]}
        onChange={(e) =>
          setFields((f) => ({ ...f, groupSequence: e.target.value }))
        }
      />,
    ],
    [
      TableColumnKey.GroupName,
      <MpTextField
        label={tc("phInputField", {
          fieldName: t(TableColumnKey.GroupName),
        })}
        value={fields[FilterFieldsKeys.GroupName]}
        onChange={(e) =>
          setFields((f) => ({ ...f, groupName: e.target.value }))
        }
      />,
    ],
    [
      TableColumnKey.GroupType,
      <NodeTypesEnumSingleSelection
        label={tc("phSelection", {
          fieldName: t(TableColumnKey.GroupType),
        })}
        value={fields.groupType}
        onChange={(e) =>
          setFields((f) => ({ ...f, groupType: e.target.value }))
        }
        enumData={SweepDestGroupType}
        clearSelect={() => {}}
      />,
    ],
    [
      TableColumnKey.Status,
      <SingleSelection
        label={tc("phSelection", { fieldName: t(TableColumnKey.Status) })}
        value={fields[FilterFieldsKeys.Status]}
        onChange={(e) =>
          setFields((f) => ({
            ...f,
            status: e.target.value,
          }))
        }
        enumData={{
          Enable: SweepDestStatus.Enable.toString(),
          Disable: SweepDestStatus.Disable.toString(),
          Deleted: SweepDestStatus.Deleted.toString(),
        }}
        nameFn={(name) => translate(`enumAutoSweepDestStatus.${name}`)}
        clearSelect={() => {}}
      />,
    ],
    [
      TableColumnKey.Active,
      <SingleSelection
        label={tc("phSelection", { fieldName: t(TableColumnKey.Active) })}
        value={fields[FilterFieldsKeys.Actice]}
        onChange={(e) =>
          setFields((f) => ({
            ...f,
            active: e.target.value,
          }))
        }
        enumData={{
          true: "true",
          false: "false",
        }}
        isNoSorting
        nameFn={(name) => toYesNo(name)}
        clearSelect={() => {}}
      />,
    ],
  ]);

  const renderFields = () =>
    Object.keys(filterFields).map((key, index) => (
      <Fragment key={index}>{filterFields[key]}</Fragment>
    ));

  return { renderFields };
};
export default useRenderFilters;
